import {
  UpdateCustomerResponseSchema,
  type UpdateCustomerRequestPayload,
  type UpdateCustomerResponse,
} from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidateCustomersQueries, invalidateInvoicesQueries } from '../../utils/query-invalidation';

export function useUpdateCustomer(
  customerId: string,
  options?: UseMutationOptions<UpdateCustomerResponse, unknown, UpdateCustomerRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    async (updateCustomerRequest) => {
      const api = getPrivateApi();
      const updateCustomerResponse = await api.updateCustomer({
        customerId,
        updateCustomerRequest,
      });

      return UpdateCustomerResponseSchema.parse(updateCustomerResponse);
    },
    {
      onSuccess: async () => {
        await Promise.all([
          invalidateCustomersQueries(queryClient),
          invalidateInvoicesQueries(queryClient),
        ]);
      },
      ...options,
    },
  );
}
